import { Navigate, Outlet } from 'react-router-dom';
import { useWorkspace } from '../workspace/WorkspaceProvider';
import { isAdvisorWithoutAdmin } from '../lib/cashFlowAccess';

/**
 * Route guard for the cash flow pages (steward-app#2592): a firm advisor who is not a workspace admin
 * is sent home, matching the hidden nav item (`useCanReadCashFlow`). While membership is still
 * resolving, render nothing rather than flash the page. UX gating, not the boundary.
 */
export function RequireCashFlowAccess() {
  const { activeMembership } = useWorkspace();
  if (!activeMembership) return null;
  if (isAdvisorWithoutAdmin(activeMembership.roleIds)) return <Navigate to="/" replace />;
  return <Outlet />;
}
